import React from 'react';

const MentionPanel = React.lazy(function importMentionPanel() {
  return import('./panel');
});

export default MentionPanel;
